/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect } from "react";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { CarouselComponentEditWrapper } from "cms/components/components/hero/edit/component-hero-wrapper";
import { HeroNewSlideEditor } from "cms/components/components/hero/edit/hero-slide-editor";
import { ErrorBoundary } from "react-error-boundary";
import { FieldErrorFallback } from "cms/fields/layout/field-error";
import LabelledField from "components/labelled-field/index";
import { MenuItem, Select } from "@mui/material";

const HeroComponentEditor = () => {
    const { component, update } = useUpdateComponent();
    const { slides } = component;
    const image_position = component?.image_position || "background";
    // console.log('[onChangeList] original',slides)

    // Initialize image_position to "background" if it doesn't exist
    useEffect(() => {
        if (!component?.image_position) {
            update("image_position", "background");
        }
    }, [component?.image_position, update]);

    const onChangeList = (slides) => {
        // console.log('[onChangeList] slides',slides)
        update("slides", slides);
    };

    const onChangeImagePosition = (event) => {
        const placement = event.target.value || "background";
        update("image_position", placement);
    };

    return (
        <div className="simplicity-editor-frame">
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    location.reload();
                }}
            >
                {/* Add image postion dropdown here */}
                <LabelledField isRequired label="Image Position" style={{ marginBottom: 16 }}>
                    <Select
                        id="hero-image-position"
                        value={image_position || "background"}
                        onChange={onChangeImagePosition}
                        fullWidth
                    >
                        <MenuItem value="left">Left</MenuItem>
                        <MenuItem value="right">Right</MenuItem>
                        <MenuItem value="background">Background</MenuItem>
                    </Select>
                </LabelledField>
                <CarouselComponentEditWrapper slides={slides} onChangeList={onChangeList}>
                    {/* Hero Carousel Slide */}
                    <HeroNewSlideEditor />
                </CarouselComponentEditWrapper>
            </ErrorBoundary>
        </div>
    );
};
HeroComponentEditor.displayName = "HeroComponentEditor";
export { HeroComponentEditor };
